import { Field, getIn } from "formik";
import NumberFormat from "react-number-format";
import React from "react";

import { formatMobileNumber } from "../../../utils/formInputUtils";
import InputError from "../InputError";
import Label from "../Label";

const MobileInput = (props) => {
  const { disabled, errors, formEl, inputClasses, touched } = props;

  let errorData = getIn(errors, formEl.name);
  let isTouched = getIn(touched, formEl.name);
  const className = `Input ${errorData && isTouched ? "is-invalid" : ""} ${
    inputClasses ? inputClasses : ""
  }`;

  const handleChange = (values, setFieldValue, setFieldTouched) => {
    const { formattedValue, value } = values;

    setFieldValue(formEl.name, value);
    setFieldTouched(formEl.name);
  };

  return (
    <div className="FormGroup">
      <Label>{formEl.elementConfig.label}</Label>
      <Field
        name={formEl.name}
        render={({ field, form }) => {
          const { name, onBlur, value } = field;
          const { setFieldTouched, setFieldValue } = form; // `FormikBag`

          return (
            <NumberFormat
              className={className}
              disabled={disabled}
              format={formatMobileNumber}
              name={name}
              onBlur={onBlur}
              onValueChange={(values) => handleChange(values, setFieldValue, setFieldTouched)}
              placeholder={formEl.elementConfig.placeholder}
              value={value}
            />
          );
        }}
      />

      {errorData && isTouched ? <InputError>{errorData}</InputError> : null}
    </div>
  );
};

export default MobileInput;
